import { getFormattedTimeWindow } from '@modules/charts/utils';
import { getDateRangeEndTime } from '@modules/common/utils';
import dayjs from 'dayjs';
import { AggregatePeriod } from 'v2/core/entities';

interface GetFormattedAnomalousTimeRangeParams {
  anomalousTimestamp: number;
  aggregatePeriod: AggregatePeriod;
}

export const getFormattedAnomalousTimeRange = ({
  anomalousTimestamp,
  aggregatePeriod,
}: GetFormattedAnomalousTimeRangeParams) => {
  const startDate = dayjs(anomalousTimestamp).tz();
  const endDate = getDateRangeEndTime(startDate, aggregatePeriod);

  return getFormattedTimeWindow({
    startDate,
    endDate,
    aggregatePeriod,
    customMonthYearFormat: 'MMMM, YYYY',
  });
};
